import React from 'react';
import Home from "./Home";
import Education from "./Education";
import Skills from "./Skills";
import Projects from "./Projects";
import Interests from "./Interests";
import About from "./About";
import Experience from './Experience';

const MainPanel = (props) => {
    return (
        <>
            {
                props.active === "home" ? (<Home setActive={props.setActive} />) : null
            }

            {
                props.active === "about" ? (<About setActive={props.setActive} />) : null
            }

            {
                props.active === "education" ? (<Education setActive={props.setActive} />) : null
            }

            {
                props.active === "experience" ? (<Experience setActive={props.setActive} />) : null
            }

            {
                props.active === "skills" ? (<Skills setActive={props.setActive} />) : null
            }

            {
                props.active === "projects" ? (<Projects setActive={props.setActive} />) : null
            }

            {
                props.active === "interests" ? (<Interests setActive={props.setActive} />) : null
            }
        </>
    )
}

export default MainPanel